/** @format */

import {SavedOrdersProvider, useSavedOrdersContext} from './saved_orders_context_provider';
import {Link, useNavigate} from 'react-router-dom';
import {Loading, IfElse} from 'frontier-utilities';
import {Button, Tab, Tabs} from '@sttark/design-system';
import {OrdersList} from './orders_list';
import {If} from 'frontier-utilities';
import React from 'react';

// styles
import './container.scss';

const Container = () => {
    const {handleLoadMore, isLoadingMore, isLoading, orders, hasMoreResults} =
        useSavedOrdersContext();

    const navigate = useNavigate();

    if (isLoading) return <Loading height="200px" />;

    if (orders.length === 0) {
        return (
            <div>
                <h3>Saved Quotes</h3>
                <Link to="/account/orders/advanced-quoter">Quick Quoter</Link>

                <div className="saved-orders-27jg">
                    <div className="alert alert-info">
                        It appears you do not have any saved quotes.{' '}
                        <a href="/orders/custom-labels">Order Now!</a>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="saved-orders-27jg">
            <div className="d-flex align-items-center justify-content-end">
                <Button
                    onClick={() => navigate('/account/orders/advanced-quoter')}
                    label="Advanced Quoter"
                    primary
                    small
                />
            </div>

            <OrdersList orders={orders} />
            <If condition={hasMoreResults}>
                <IfElse condition={!isLoadingMore}>
                    <button
                        className="p-0 m-auto d-flex align-items-center justify-content-center mt-4 color-accent-primary"
                        onClick={handleLoadMore}>
                        Load More
                    </button>
                    <button
                        disabled="disabled"
                        className="p-0 m-auto d-flex align-items-center justify-content-center mt-4 color-structure-darker gap-4">
                        <i className="fa fa-spinner fa-spin" />
                        <span>Loading...</span>
                    </button>
                </IfElse>
            </If>
        </div>
    );
};

export const SavedOrders = () => {
    return (
        <SavedOrdersProvider>
            <Container />
        </SavedOrdersProvider>
    );
};
